<button
	[id]="id()"
	(click)="openLink()"
	class="w-full card focus:outline-black"
	data-test-class="tile"
>
	<div
		[ngClass]="{ 'pointer-events-none': preventClickEvents() }"
		class="flex w-full min-w-0 flex-col flex-nowrap items-center gap-2"
	>
		<div
			class="icon-container-md-full icon-fill-accent"
			data-test-id="tile-icon"
		>
			<svg-icon [attr.data-test-id]="icon()" [src]="icon()" />
		</div>
		<span
			[title]="title()"
			class="w-full min-w-0 truncate text-center text-sm font-semibold md:text-base"
			data-test-id="tile-title"
		>
			{{ title() }}
		</span>
	</div>
</button>
